(function() {
    var __webpack_require__ = {};
    !function() {
        __webpack_require__.r = function(exports) {
            if (typeof Symbol !== "undefined" && Symbol.toStringTag) {
                Object.defineProperty(exports, Symbol.toStringTag, {
                    value: "Module"
                });
            }
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
        };
    }();
    var __webpack_exports__ = {};
    !function() {
        if (!window.customElements.get("erk-friction-tabs")) {
            class ERKFrictionTabs extends HTMLElement {
                constructor() {
                    super();
                    this.handleClick = this.handleClick.bind(this);
                    this.handleKeydown = this.handleKeydown.bind(this);
                }
                connectedCallback() {
                    this.desktopTabs = Array.from(this.querySelectorAll(".erk-friction-tabs__card"));
                    this.mobileTabs = Array.from(this.querySelectorAll(".erk-friction-tabs__mobile-trigger"));
                    this.desktopPanels = Array.from(this.querySelectorAll(".erk-friction-tabs__desktop-panel"));
                    this.mobilePanels = Array.from(this.querySelectorAll(".erk-friction-tabs__mobile-panel"));
                    this.addEventListener("click", this.handleClick);
                    this.addEventListener("keydown", this.handleKeydown);
                }
                disconnectedCallback() {
                    this.removeEventListener("click", this.handleClick);
                    this.removeEventListener("keydown", this.handleKeydown);
                }
                handleClick(event) {
                    const trigger = event.target.closest(".erk-friction-tabs__card, .erk-friction-tabs__mobile-trigger");
                    if (!trigger || !this.contains(trigger)) {
                        return;
                    }
                    this.setActiveIndex(Number(trigger.dataset.index));
                }
                handleKeydown(event) {
                    const tab = event.target.closest(".erk-friction-tabs__card");
                    if (!tab || !this.contains(tab) || this.desktopTabs.length === 0) {
                        return;
                    }
                    const currentIndex = this.desktopTabs.indexOf(tab);
                    let nextIndex = currentIndex;
                    if (event.key === "ArrowRight" || event.key === "ArrowDown") {
                        nextIndex = (currentIndex + 1) % this.desktopTabs.length;
                    } else if (event.key === "ArrowLeft" || event.key === "ArrowUp") {
                        nextIndex = (currentIndex - 1 + this.desktopTabs.length) % this.desktopTabs.length;
                    } else if (event.key === "Home") {
                        nextIndex = 0;
                    } else if (event.key === "End") {
                        nextIndex = this.desktopTabs.length - 1;
                    } else {
                        return;
                    }
                    event.preventDefault();
                    this.desktopTabs[nextIndex].focus();
                    this.setActiveIndex(nextIndex);
                }
                setActiveIndex(activeIndex) {
                    this.desktopTabs.forEach((function(tab, index) {
                        const isActive = index === activeIndex;
                        const badge = tab.querySelector(".erk-friction-tabs__card-badge");
                        tab.classList.toggle("is-active", isActive);
                        tab.setAttribute("aria-selected", isActive ? "true" : "false");
                        if (badge) {
                            badge.classList.toggle("erk-friction-tabs__card-badge--muted", !isActive);
                        }
                    }));
                    this.mobileTabs.forEach((function(tab, index) {
                        const isActive = index === activeIndex;
                        const badge = tab.querySelector(".erk-friction-tabs__mobile-badge");
                        tab.classList.toggle("is-active", isActive);
                        tab.setAttribute("aria-expanded", isActive ? "true" : "false");
                        if (badge) {
                            badge.classList.toggle("erk-friction-tabs__mobile-badge--muted", !isActive);
                        }
                    }));
                    this.desktopPanels.forEach((function(panel, index) {
                        panel.hidden = index !== activeIndex;
                    }));
                    this.mobilePanels.forEach((function(panel, index) {
                        panel.hidden = index !== activeIndex;
                    }));
                }
            }
            window.customElements.define("erk-friction-tabs", ERKFrictionTabs);
        }
    }();
    !function() {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
    }();
})();